export default __webpack_public_path__ + "static/media/talk_phone.d47b4b97.svg";